import privacy from '../commonAssets/beemPrivacyText';
import deleteAccountText from '../commonAssets/deleteAccountText';
import terms from '../commonAssets/termsText';
import chatLogo from './assets/chat_logo.svg';
import favicon from './assets/favicon.svg';
import opIcon from './assets/hti-op-icon.svg';
import imprint from './assets/imprintText';
import logo from './assets/logo.svg';
import simpleLogo from './assets/simple_logo.svg';

const config = {
  title: 'HTI BEEM',
  description:
    'Mit BEEM stellen Kunden ihrem persönlichen HTI-Kontakt jederzeit schnell und einfach Fragen – immer rechtssicher!',
  identifier: 'hti',
  appName: 'HTI',
  defaultBrand: 'HTI',
  url: 'htibeem.de',
  apiBaseUrl: 'https://api.htibeem.de',
  helpUrl: 'https://hilfe.getbeem.de/',
  iosStoreUrl: 'https://apps.apple.com/us/app/hti-beem/id1612674827',
  androidStoreUrl: 'https://play.google.com/store/apps/details?id=de.htibeem',
  supportEmail: 'support@getbeem.de',
  favicon,
  logo,
  chatLogo,
  simpleLogo,
  packageId: 'de.htibeem',
  privacyText: privacy,
  termsText: terms,
  usercentricsId: 't3PD9dOk5',
  imprintText: imprint,
  deleteAccountText,
  welcomeText: 'Willkommen bei HTI BEEM!',
  identifierPlaceholder: 'Mobilnummer oder E-Mail Adresse',
  mainText: 'Bitte geben Sie Ihre Mobilnummer oder E-Mail Adresse ein, um sich anzumelden.',
  opIcon,
};

export default config;
